import { isProblem } from '@trello/paid-account';
import { getBannerMessageName } from './getBannerMessageName';
import type { Member } from 'app/scripts/models/member';

export const getOverdueOrganization = function (member: Member) {
  const paidOrgs = member.organizationList.filter(
    (org) =>
      !!org.get('paidAccount') &&
      org.hasPaidProduct() &&
      org.ownedByMember(member) &&
      !org.paysWithPurchaseOrder(),
  );

  for (const paidOrg of Array.from(paidOrgs)) {
    const paidAccount = paidOrg.get('paidAccount')!;
    const bannerName = getBannerMessageName(paidOrg.id, paidAccount);

    if (
      isProblem(paidAccount.standing) &&
      !paidAccount.needsCreditCardUpdate &&
      !member.isDismissed(bannerName)
    ) {
      return paidOrg;
    }
  }

  return null;
};
